module.exports = __webpack_public_path__ + "static/img/Nathan.Lovett-Murray.f0fd4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathan.Lovett-Murray.jpg
// module id = 0Z7C
// module chunks = 0